import { Box, Skeleton, Stack } from '@mui/material'

const ChartSkeleton = () => {
  return (
    <Stack spacing={2} sx={{ width: '100%', height: '100%', p: 2, pb: 5 }}>
      <Stack direction="row" spacing={2}>
        {[...Array(2)].map((_, i) => (
          <Stack key={i} direction="row" spacing={1} alignItems="center">
            <Skeleton variant="circular" width={12} height={12} />
            <Skeleton variant="text" width={60} />
          </Stack>
        ))}
      </Stack>
      
      <Box sx={{ flex: 1, position: 'relative' }}>
        <Skeleton 
          variant="rectangular" 
          animation="wave"
          sx={{ 
            width: '100%',
            height: '100%',
            transform: 'none',
            borderRadius: 1,
            clipPath: 'polygon(0 20%, 20% 40%, 40% 10%, 60% 30%, 80% 15%, 100% 35%, 100% 100%, 0 100%)'
          }} 
        />
        
        <Stack 
          direction="row" 
          justifyContent="flex-end"
          spacing={2}
          sx={{ mt: 1, pr: 2 }}
        >
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} variant="text" width={40} />
          ))}
        </Stack>
      </Box>
    </Stack>
  )
}

export default ChartSkeleton
